// Generated by CoffeeScript 1.9.1
var Loader, Model, Package;
Loader = require("../utils/loader");
Model = require("backbone-thin").Model;
module.exports = Package = Model.extend({
  initialize: function initialize(g) {
    return this.g = g;
  },
  development: {
    "msa-tnt": "/node_modules/msa-tnt/build/bundle.js",
    "biojs-io-newick": "/node_modules/biojs-io-newick/build/biojs-io-newick.min.js"
  },
  loadPackage: function loadPackage(pkg, cb) {
    var p;
    try {
      p = require(pkg);
      return cb(p);
    } catch (_error) {
      return Loader.loadScript(this._pkgURL(pkg), cb);
    }
  },
  loadPackages: function loadPackages(pkgs, cb) {
    var cbs;
    cbs = Loader.joinCb(function () {
      return cb();
    }, pkgs.length);
    return pkgs.forEach(function (_this) {
      return function (pkg) {
        return _this.loadPackage(pkg, cbs);
      };
    }(this));
  },
  _pkgURL: function _pkgURL(pkg) {
    var url;
    if (this.g.config.get("debug")) {
      url = this.development[pkg];
    } else {
      url = "http://wzrd.in/bundle/" + pkg + "@latest";
    }
    return url;
  }
});